(() => {
  if (customElements.get('zelink-nad-order')) return;
  class ZelinkNadOrder extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.forms = new WeakSet();
      this.observer = new MutationObserver(() => this.schedule());
      this.observer.observe(document.body, {childList: true, subtree: true});
      this.schedule();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      cancelAnimationFrame(this.frame);
    }
    schedule() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {this.frame = null; this.enhance();});
    }
    label(input, text) {
      const label = input?.closest('._rsi-modal-fields-item')?.querySelector('label');
      if (!label) return;
      label.htmlFor = input.id;
      const node = [...label.childNodes].find(n => n.nodeType === Node.TEXT_NODE);
      if (node && node.textContent !== text) node.textContent = text;
    }
    enhance() {
      const modal = document.getElementById('_rsi-cod-form-modal');
      const form = modal?.querySelector('#_rsi-cod-form-modal-form');
      const item = form?.querySelector(`[data-line-item-variant-id="${this.dataset.variantId}"]`);
      if (!item) return;
      modal.setAttribute('data-zelink-nad-order', '');
      const header = form.querySelector('._rsi-modal-header-title');
      if (header?.style.getPropertyValue('color') !== 'rgb(255, 255, 255)') header?.style.setProperty('color', '#fff', 'important');
      form.querySelectorAll('._rsi-custom-text-field').forEach(text => {
        if (text.style.getPropertyValue('color') !== 'rgb(229, 225, 214)') text.style.setProperty('color', '#e5e1d6', 'important');
      });
      if (!this.forms.has(form)) {
        const address = form.elements.namedItem('address');
        const extra = form.elements.namedItem('civic_number');
        const city = form.elements.namedItem('city');
        const summary = form.querySelector('._rsi-build-block-order-summary');
        if (!address || !extra || !city || !summary) return;
        this.forms.add(form);
        const signal = this.controller.signal;
        form.addEventListener('change', () => this.schedule(), {signal});
        const intro = this.querySelector('[data-order-intro]').content.cloneNode(true);
        summary.before(intro);
        const destination = this.querySelector('[data-order-destination]').content.cloneNode(true);
        city.closest('._rsi-modal-fields-item').after(destination);
        const choice = form.querySelector('#zn-delivery-destination');
        choice.closest('._rsi-modal-fields-item').after(address.closest('._rsi-modal-fields-item'));
        address.closest('._rsi-modal-fields-item').after(extra.closest('._rsi-modal-fields-item'));
        const phone = form.elements.namedItem('phone');
        this.label(phone, this.dataset.phone);
        phone.inputMode = 'tel';
        const firstName = form.elements.namedItem('first_name');
        firstName.autocomplete = 'name';
        for (const field of [firstName, phone, address, extra, city, form.elements.namedItem('province_country_field')]) {
          const label = field.closest('._rsi-modal-fields-item')?.querySelector('label');
          if (label) label.htmlFor = field.id;
        }
        const values = {home:{address:address.value, extra:extra.value}, office:{address:'', extra:''}};
        let previous = 'home';
        const notify = input => {
          input.dispatchEvent(new Event('input', {bubbles:true}));
          input.dispatchEvent(new Event('change', {bubbles:true}));
        };
        const update = changed => {
          const mode = choice.value;
          if (changed) {
            values[previous] = {address:address.value, extra:extra.value};
            address.value = values[mode].address;
            extra.value = values[mode].extra;
            previous = mode;
            notify(address); notify(extra);
          }
          this.label(address, this.dataset[mode+'Address']);
          this.label(extra, this.dataset[mode+'Extra']);
          address.placeholder = this.dataset[mode+'Placeholder'];
          extra.placeholder = this.dataset[mode+'ExtraPlaceholder'];
          address.autocomplete = mode === 'home' ? 'address-line1' : 'off';
          extra.autocomplete = mode === 'home' ? 'address-line2' : 'off';
          form.dataset.zelinkDestination = mode;
        };
        choice.addEventListener('change', () => update(true), {signal});
        const normalizeOffice = () => {
          if (choice.value !== 'office' || !address.value.trim()) return;
          const prefix = this.dataset.officePrefix;
          if (!address.value.startsWith(prefix)) {
            address.value = prefix + address.value.trim();
            notify(address);
          }
        };
        address.addEventListener('blur', normalizeOffice, {signal});
        form.addEventListener('submit', normalizeOffice, {capture:true, signal});
        form.querySelector('._rsi-modal-submit-button')?.addEventListener('click', normalizeOffice, {capture:true, signal});
        update(false);
      }
      const info = item.querySelector('._rsi-modal-line-item-info');
      let quantity = info?.querySelector('.zn-quantity');
      if (info && !quantity) {
        quantity = document.createElement('span');
        quantity.className = 'zn-quantity';
        info.append(quantity);
      }
      const value = item.querySelector('[name="item_quantity[0]"]')?.value || item.querySelector('._rsi-modal-line-item-quantity')?.textContent.trim();
      const quantityText = this.dataset.quantity + ': ' + value;
      if (quantity && quantity.textContent !== quantityText) quantity.textContent = quantityText;
      const originalImage = item.querySelector('._rsi-modal-line-item-image');
      const imageContainer = originalImage?.parentElement;
      if (imageContainer && originalImage.currentSrc) {
        const count = Math.min(3, Math.max(1, parseInt(value, 10) || 1));
        let products = imageContainer.querySelector('.zn-selected-products');
        if (!products) {
          products = document.createElement('div');
          products.className = 'zn-selected-products';
          products.setAttribute('aria-hidden', 'true');
          imageContainer.append(products);
        }
        if (products.dataset.quantity !== String(count) || products.dataset.src !== originalImage.currentSrc) {
          products.replaceChildren();
          for (let unit = 0; unit < count; unit++) {
            const frame = document.createElement('span');
            frame.className = 'zn-product-crop';
            const image = document.createElement('img');
            image.src = originalImage.currentSrc;
            image.alt = '';
            frame.append(image);
            products.append(frame);
          }
          products.dataset.quantity = count;
          products.dataset.src = originalImage.currentSrc;
          imageContainer.classList.add('zn-product-visual');
        }
      }
      const button = form.querySelector('._rsi-modal-submit-button');
      if (button && !button.disabled) {
        button.style.setProperty('background', '#d8c9a8', 'important');
        button.style.setProperty('color', '#191711', 'important');
        button.style.setProperty('border-radius', '12px', 'important');
        const label = [...(button.querySelector('span')?.childNodes || [])].find(n => n.nodeType === Node.TEXT_NODE);
        if (label && label.textContent !== this.dataset.confirm) label.textContent = this.dataset.confirm;
      }
    }
  }
  customElements.define('zelink-nad-order', ZelinkNadOrder);
})();
